// Централизованное чтение переменных окружения Vite
// Все значения для разных окружений настраиваются через файлы .env.*

const rawApiHost = import.meta.env.VITE_API_HOST || "http://localhost:8000";
const rawTelegramBotUsername = import.meta.env.VITE_TELEGRAM_BOT_USERNAME || "quantilecampbot";

export const env = {
  // Базовый URL Backend API (без завершающего слеша)
  API_HOST: rawApiHost.replace(/\/$/, ""),
  // Имя Telegram-бота для виджета логина
  TELEGRAM_BOT_USERNAME: rawTelegramBotUsername,
} as const;


